import { render, staticRenderFns } from "./ReadAloudPreview.vue?vue&type=template&id=53e1d332&scoped=true&"
import script from "./ReadAloudPreview.vue?vue&type=script&lang=js&"
export * from "./ReadAloudPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReadAloudPreview.vue?vue&type=style&index=0&id=53e1d332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e1d332",
  null
  
)

export default component.exports